import { store } from '../index'

const validConfirmedTypes = ['3x4_1r', '6x2_1r']

const onFileUpload = async (files, ecg) => {
  store.doSetDialogLoading()
  const pdf = new FormData()
  pdf.append('ecg', files[0])
  await store.doUploadPDF(pdf, ecg.id)
  await store.doFetchEcgDialogData()
  await store.doFetchEcgChangeHistory()
  await store.doFetchECGS()
}

const onConfirmedFileUpload = async (files, ecg) => {
  store.doSetDialogLoading()
  const patientNameSlug = ecg?.patient?.name?.replace(' ', '-',)?.toUpperCase()
  const date = ecg.createdOn.split('T')[0]
  const totalFiles = files?.length
  let index = 1
  let newData = null
  for (const f of files) {
    const data = new FormData()
    let docType = false
    validConfirmedTypes.forEach(validType => {
      if (f.name.toLowerCase().includes(validType)) docType = validType
    })
    if (!docType) {
      store.doSetSnackbarFail(`Archivo debe contener uno de estos tipos de trazo confirmado: ${validConfirmedTypes}`)
      return
    }
    const fileName = `CONFIRMED__Trazo_confirmado_${docType}_${ecg.id}_${date}_${patientNameSlug}.pdf`
    data.append('file', f)
    data.append('name', fileName)
    newData = await store.doUploadEcgDocument(data, ecg.id, `${index}/${totalFiles}`)
    index++
  }
  return newData
}

export const uploadOcrTrace = (files, ecg) => onFileUpload(files, ecg)
export const uploadConfirmedTrace = (files, ecg) => onConfirmedFileUpload(files, ecg)

export default {
  onFileUpload: async (event, id) => {
    const pdf = new FormData()
    pdf.append('ecg', event.target.files[0])
    store.doSetAppLoading()
    await store.doUploadPDF(pdf, id)
    await store.doFetchEcgDialogData()
    store.doSetAppIdle()
  },
  onClickTrace: ecg => {
    store.doSetDialogAction('uploadOcrTrace')
    store.doSetDialogTitle(ecg.hasTrace ? 'Reemplazar trazo sin confirmar' : 'Cargar trazo sin confirmar')
    store.doSetRelatedEcg(ecg)
    store.doOpenDialog()
  },
  onClickSendReportEmail: async (action, ecg) => {
    await store.doSendEcgReportEmail(ecg.id)
  },
  onClickReportQr: async (action, ecg) => {
    await store.doGetPublicReportQr(ecg.id)
  },
  onClickConfirmedUpload: ecg => {
    store.doSetDialogAction('uploadConfirmedTrace')
    store.doSetDialogTitle('Cargar trazo(s) confirmado(s)')
    store.doSetRelatedEcg(ecg)
    store.doOpenDialog()
  },
  onReportClick: async (action, ecg) => {
    await store.doGenerateReport(ecg.id)
  },
  onClickViewTrace: (action, ecg) => {
    window.open(ecg.ecg, '_blank')
  },
  onClickViewConfirmedTrace: ecg => {
    store.doSetFileBrowserSetFiles(ecg)
    store.doSetFileBrowserOpen()
  },
  onClickDelete: async (action, ecg) => {
    await store.doSoftDeleteECG(ecg.id)
    let softDeleted = localStorage.getItem('softDeletedItems').split(',').map(Number)
    softDeleted.push(ecg.id)
    softDeleted = softDeleted.filter(e => !Number.isNaN(e))
    localStorage.setItem('softDeletedItems', softDeleted.join(','))
    await store.doFetchECGS()
  },
  onEditClick: async (action, ecg) => {
    store.doSetOpenedFromTable(true)
    store.doSetSelectedEcgId(ecg.id)
    await store.doFetchEcgDialogData(ecg)
    await store.doFetchEcgChangeHistory(ecg)
    store.doOpenEcgDialog()
    store.doUpdateUrl(`/estudio/${ecg.id}/`)
  },
  onClickAssignTrace: async (ecg) => {
    await store.doFetchAssignTracesTableList()
    store.doSetAssignTracesSelectedEcg(ecg)
    store.doSetAssignTracesTableSelectedItem(ecg?.assignedTrace ?? null)
    store.doSetAssignTracesOpenDialog(true)
  }
}
